module.exports = __webpack_public_path__ + "eac0f6d6f2f4ae64f6de0940cbdbfced.svg";